export const BASE_SKU = '41000';
